import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * FAQShortcode - Renders a single FAQ item with accordion behavior
 * 
 * Usage in admin:
 * {{faq:"Question text here?", "Answer text here with full explanation."}}
 */

const FAQShortcode = ({ params = [] }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  // Extract question and answer from params
  const question = params[0] || t('appMisc.questionNotProvided');
  const answer = params[1] || t('appMisc.answerNotProvided');

  return (
    <div className="border-b border-gray-200 py-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-start justify-between text-left gap-4 group"
      >
        <span className="text-lg font-medium text-[#2C2420] group-hover:text-[#be1f1a] transition-colors flex-1">
          {question}
        </span>
        <span className="flex-shrink-0 mt-1">
          {isOpen ? (
            <ChevronUp className="h-5 w-5 text-[#be1f1a]" />
          ) : (
            <ChevronDown className="h-5 w-5 text-gray-400 group-hover:text-[#be1f1a] transition-colors" />
          )}
        </span>
      </button>
      
      {isOpen && (
        <div className="mt-4 pr-12">
          <div 
            className="text-gray-600 leading-relaxed prose prose-sm max-w-none"
            dangerouslySetInnerHTML={{ __html: answer }}
          />
        </div>
      )}
    </div>
  );
};

export default FAQShortcode;
